import {
  STYLEBOARD_COPY_DELETE_STYLEBOARD,
  STYLEBOARD_COPY_SAVED,
  STYLEBOARD_COPY_COPIED_THE_LINK,
} from 'features/Styleboard/copyKeys'
import { Notification, NotificationType } from 'features/Styleboard/types'

export const copyStyleboardLinkNotification = {
  id: 'copy-styleboard-link',
  message: STYLEBOARD_COPY_COPIED_THE_LINK,
  type: 'info',
  notification: NotificationType.COPY_STYLEBOARD_LINK,
} as Notification

export const deleteStyleboardNotificationFail = {
  id: 'delete-styleboard',
  message: STYLEBOARD_COPY_DELETE_STYLEBOARD,
  type: 'error',
  notification: NotificationType.STYELBOARD_DELETED_FAILED,
} as Notification

export const followStyleboardFailed = {
  id: 'follow-styleboard',
  message: 'text.oops.error',
  type: 'error',
  notification: NotificationType.FOLLOW_STYLEBOARD_FAILED,
} as Notification

export const putProfileFailNotification = {
  id: 'put-profile-styleboard',
  message: 'text.oops.error',
  type: 'error',
  notification: NotificationType.PUT_PROFILE_FAILED,
} as Notification

export const putStyleboardFailedNotification = {
  id: 'put-styleboard-failed',
  message: 'text.oops.error',
  type: 'error',
  notification: NotificationType.PUT_STYLEBOARD_FAILED,
} as Notification

export const putProfileNotification = {
  id: 'put-profile-styleboard',
  message: STYLEBOARD_COPY_SAVED,
  type: 'success',
  notification: NotificationType.PUT_PROFILE_SUCCEEDED,
} as Notification

export const putStyleboardNotification = {
  id: 'put-styleboard',
  message: STYLEBOARD_COPY_SAVED,
  type: 'success',
  notification: NotificationType.PUT_STYLEBOARD_SUCCEDED,
} as Notification

export const addImageToStyleboardNotificationFailed = {
  id: 'add-image-styleboard-failed',
  message: 'text.oops.error',
  type: 'error',
  notification: NotificationType.ADD_IMAGE_STYLEBOARD_FAILED,
} as Notification

export const deleteItemFromStyleboardFailed = {
  id: 'delete-item-from-styleboard-failed',
  message: 'text.oops.error',
  type: 'error',
  notification: NotificationType.ADD_IMAGE_STYLEBOARD_FAILED,
} as Notification

export const fetchFollowStyleboardsFail = {
  id: 'fetch-follow-styleboards-failed',
  message: 'text.oops.error',
  type: 'error',
  notification: NotificationType.FETCH_FOLLOW_STYLEBOARDS_FAILED,
} as Notification

export const fetchStyleboardsFail = {
  id: 'fetch-styleboards-failed',
  message: 'text.oops.error',
  type: 'error',
  notification: NotificationType.FETCH_STYLEBOARDS_FAILED,
} as Notification

export const changeBackgroundImageFailed = {
  id: 'change-background-image-failed',
  message: 'text.oops.error',
  type: 'error',
  notification: NotificationType.CHANGE_BACKGROUND_IMAGE_FAILED,
} as Notification
